import { createTrpcClient } from '@/lib/trpc/client';

let cachedClient: ReturnType<typeof createTrpcClient> | null = null;

export const getBrowserTrpcClient = () => {
  if (!cachedClient) {
    cachedClient = createTrpcClient();
  }
  return cachedClient;
};

export const resetBrowserTrpcClient = () => {
  cachedClient = null;
};
